<h1 class="title" [class.title-centered]="centered">
  <ng-content></ng-content>
</h1>
